var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tooltip',{attrs:{"content":"全屏"}},[_c('Icon',{staticStyle:{"cursor":"pointer"},attrs:{"type":_vm.icon_type,"size":"23"},on:{"click":_vm.switch_full}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }